import { CreatorsToActions } from '../helper'

type Actions = CreatorsToActions<typeof import('../actions/searchQueryMessages')>

interface State {
  page: string
  kaiin_no: string
  name: string
  affiliation: string
  message: string
  unread: boolean
  user_unread: boolean
  messagefilter: string
  unreadfilter: string
  user_unreadfilter: string
}
// ______________________________________________________
//
export function initialState(injects?: State): State {
  return {
    page: '',
    kaiin_no: '',
    name: '',
    affiliation: '',
    message: '',
    unread: false,
    user_unread: false,
    messagefilter: '',
    unreadfilter: '',
    user_unreadfilter: ''
  }
}
// ______________________________________________________
//
export function reducer(state = initialState(), action: Actions): State {
  switch (action.type) {
    case 'SET_SEARCH_QUERY_MESSAGES':
      return {
        page: action.payload.page,
        kaiin_no: action.payload.kaiin_no,
        name: action.payload.name,
        affiliation: action.payload.affiliation,
        message: action.payload.message,
        unread: action.payload.unread,
        user_unread: action.payload.user_unread,
        messagefilter: action.payload.messagefilter,
        unreadfilter: action.payload.unreadfilter,
        user_unreadfilter: action.payload.user_unreadfilter
      }
    case 'UNSET_SEARCH_QUERY_MESSAGES':
      return {
        page: '',
        kaiin_no: '',
        name: '',
        affiliation: '',
        message: '',
        unread: false,
        user_unread: false,
        messagefilter: '',
        unreadfilter: '',
        user_unreadfilter: ''
      }
    default:
      return state
  }
}
